import React from 'react';
import { purple } from 'globals/colors';

interface FsAlertIconProps {
  color?: string;
}

const FsAlertIcon: React.FC<FsAlertIconProps> = ({ color = purple.BRAND }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2666 8.86426L16.8433 16.7168H14.104L13.6807 8.86426H17.2666ZM16.7312 20.7883C16.4296 21.0678 16.0076 21.2075 15.4653 21.2075C14.9175 21.2075 14.4886 21.0678 14.1787 20.7883C13.8688 20.5089 13.7139 20.1201 13.7139 19.6221C13.7139 19.1185 13.8633 18.727 14.1621 18.4475C14.4609 18.168 14.8953 18.0283 15.4653 18.0283C16.0298 18.0283 16.4573 18.168 16.7478 18.4475C17.0383 18.727 17.1836 19.1185 17.1836 19.6221C17.1836 20.1201 17.0328 20.5089 16.7312 20.7883Z"
        fill="white"
      />
    </svg>
  );
};

export default FsAlertIcon;
